export const ru = {
    carriage: 'Вагон',
    choose: 'Выбрать',
    choose_seat: 'Выберите место',
    seats: 'Места',
};
